import React, { useEffect, useState } from "react";
import { MediaCompChildrenSwitch } from "../components/BuildingBlocks/MediaCompChildrenSwitch";
import { FPLandingPageDesktopV2 } from "../components/FrontProbate/LandingPage/FPLandingPageDesktopV2/FPLandingPageDesktopV2";
import { ProbateLeadForm, TProbateLeadForm } from "../../../domain/codecs/form/ProbateLeadForm";
import { FPLandingPageMobile } from "../components/FrontProbate/LandingPage/FPLandingPageMobile/FPLandingPageMobile";
import { initFullStory } from "../util";
import { pipe } from "fp-ts/lib/function";
import { taskEither } from "fp-ts";

export const ProbateMarketingAppContainer = (props: {}): JSX.Element =>
    {
        const [form, setForm] = useState<TProbateLeadForm>(ProbateLeadForm.newDefault());

        const onSubmit = (submissionForm: TProbateLeadForm) => {

            const setSubmitting = (probateLeadForm: TProbateLeadForm) => {
                const probateLeadFormSubmitting: TProbateLeadForm = {
                    ...probateLeadForm,
                    status: "submitting",
                };

                setForm(probateLeadFormSubmitting);

                return probateLeadFormSubmitting;
            };

            const getCampaignName = (): string => {
                const urlParams = new URLSearchParams(window.location.search);
                return urlParams.get("source") || "";
            }

            const request = (probateLeadForm: TProbateLeadForm) => {
                return pipe(
                    taskEither.tryCatch(
                        () => fetch(`${env.REACT_APP_API_URL}/formOperation/CreateProbateLead`, {
                            credentials: "include",
                            method: "POST",
                            headers: {
                                "content-type": "application/json",
                                "accept": "application/json",
                            },
                            body: JSON.stringify({
                                ...probateLeadForm,
                                edited: {
                                    ...probateLeadForm.edited,
                                    campaign: getCampaignName(),
                                }
                            }),
                        }),
                        () => "fetch error",
                    ),
                    taskEither.chain((res) =>
                        res.status === 200
                            ? taskEither.tryCatch(
                                () => res.json(),
                                () => "json decode error",
                            )
                            : taskEither.left("unacceptable status code"),
                    ),
                )
            };

            pipe(
                submissionForm,
                setSubmitting,
                request,
                taskEither.map(setForm),
            )();
        };

        useEffect(() => {
            initFullStory();
        }, []);

        return (
            <MediaCompChildrenSwitch
                breakpoint="1200"
                DesktopChild={
                    <FPLandingPageDesktopV2 
                        form={form || ProbateLeadForm.newDefault()}
                        onChange={setForm}
                        onSubmit={onSubmit}
                    />
                }
                MobileChild={
                    <FPLandingPageMobile
                        form={form || ProbateLeadForm.newDefault()}
                        onChange={setForm}
                        onSubmit={onSubmit}
                    />
                }
            />
        );
    };
